module.exports = __webpack_public_path__ + "img/bulb.22ba715d.png";